class Cache {
  store: { [key: string]: any }
  constructor() {
    this.store = {
      ...this.init(),
    }
  }

  set(key: string, value: any) {
    this.store[key] = value
  }

  get(key: string) {
    return this.store[key]
  }

  init() {
    return {
      nav: {},
      announcement: {},
      partners: {},
      pageResource: {},
      pageResourceDemo: {},
      pageAnalystReport: {},
      pageWhitePaper: {},
      pagePlaceholder: {},
      pageWebinarRecording: {},
      componentThankYouFeaturedResource: {},
      pageBlogPost: {},
      teaser: {},
      blogFeaturedResource: {},
      subscribe: {},
      blogNavMenu: {},
      speakerTextMicrocopy: {},
      hrBlogNavMenu: {},
      communityBlogNavMenu: {},
      featuredSlider: {},
    }
  }

  reset() {
    this.store = {
      ...this.init(),
    }
  }
}

const cache = new Cache()

export default cache
